<template>
  <div class="sales-volumeDetails-container">
    <div class="mobile">
      <div class="details-container">
        <div class="info-header">
          <div>
            <span class="header-tag">人工审核</span>
            <span class="order-no">销量申报单号：91258754454</span>
          </div>
          <div class>
            <div class="gray">申报日期：2019-08-09 12:00:05</div>
            <div class="gray">提出计算时段：2019-08-10 12:00:10</div>
          </div>
        </div>
        <div class="list details-list">
          <div class="order-details">
            <div class="title">单据详情</div>
            <div class="upload-img flex">
              <el-image
                style="width: 100px; height: 100px;margin-right: 10px"
                :src="v"
                v-for="(v, i) in uploadImgList"
                :key="i"
                :preview-src-list="uploadImgList"
              ></el-image>
            </div>
          </div>
          <div
            class="list-item"
            @click="toDetails(v)"
            v-for="(v, i) in list"
            :key="i"
          >
            <div class="flex flex-between item-center">
              <div class="flex item-center">
                <div class="user-info">
                  <span class="tag">商品名称</span>
                  {{ v.goodsName }}
                </div>
              </div>
            </div>
            <div>
              <span>奖励基数：</span>
              <span class="price">{{ v.count }}%</span>
            </div>
            <div class="flex flex-between">
              <div>
                奖励基数：
                <span class="count">{{ v.count }}件</span>
              </div>
              <div>
                收益：
                <span class="price">￥{{ v.price }}</span>
              </div>
            </div>
          </div>
          <div class="total flex flex-end">
            总计收益：
            <span class="price">￥{{ 410 }}</span>
          </div>
        </div>
        <div class="list details-list">
          <div class="order-details">
            <div class="title">操作日志</div>
          </div>
          <div class="progress">
            <div class="flex" v-for="(v, i) in progress" :key="i">
              <div class="line" :class="{ active: i === 0 }"></div>
              <div class="info">
                <div>
                  <span class="status" :class="{ active: i === 0 }">{{
                    v.status
                  }}</span>
                  <span>{{ v.name }}</span>
                </div>
                <div class="gray">{{ v.time }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer flex flex-around item-center">
          <button @click="cancle" class="btn pass-btn">同意</button>
          <button class="btn reject-btn" @click="dialogVisible = true">
            驳回
          </button>
        </div>
      </div>
    </div>
    <el-dialog
      title="驳回备注?"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      custom-class="sales-volumn-dialog"
    >
      <el-form label-width="80px">
        <el-form-item label="驳回原因">
          <el-input
            maxlength="100"
            placeholder="请输入驳回原因，可直接选择下方模板"
            size="small"
            style="width: auto"
            :autosize="{ minRows: 4 }"
            type="textarea"
            v-model="reason"
          ></el-input>
        </el-form-item>
        <div class="reject-reason">
          <el-radio-group v-model="rejectReason" @change="switchRejectReason">
            <div v-for="(v, i) in rejectTemp" :key="i">
              <el-radio :label="i">{{ v }}</el-radio>
            </div>
          </el-radio-group>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitRuleForm" size="small" type="primary"
          >保存</el-button
        >
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      rejectReason: "",
      reason: "",
      rejectTemp: [
        "您输入的申报数量与实际数量不符，如有疑问请联系客服。",
        "您输入的申报商品数量存在问题，如有疑问请联系客服。",
        "您小票存在问题，如有疑问请联系客服。"
      ],
      dialogVisible: false,
      progress: [
        {
          status: "人工审核中",
          name: "唐小鸭",
          time: "2019-08-11 12:00:05"
        },
        {
          status: "自动审核中",
          name: "自动检测",
          time: "2019-08-11 12:00:05"
        }
      ],
      popupVisible: false,
      uploadImgList: [
        "https://imgcdn.hemiao100.com/hemiaoBase/1571708978783-9f046499-ba4d-48cc.jpg",
        "https://imgcdn.hemiao100.com/hemiaoBase/1571709110147-33f22e7b-c91e-426d.jpg"
      ],
      list: [
        {
          userName: "唐小丫",
          mobile: "13121869388",
          goodsName: "巴布豆婴儿浴巾新生儿浴巾毛巾组合套装1",
          date: "2019-08-09 12:00:05",
          count: "48",
          price: "109"
        },
        {
          userName: "唐小丫",
          mobile: "13121869388",
          goodsName: "巴布豆婴儿浴巾新生儿浴巾毛巾组合套装1",
          date: "2019-08-09 12:00:05",
          count: "48",
          price: "109"
        }
      ]
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    switchRejectReason() {
      this.reason = this.rejectTemp[this.rejectReason];
    },
    cancle() {},
    submitRuleForm() {}
  }
};
</script>
<style lang="scss" scoped>
.mobile {
  display: none;
}
@media screen and (max-width: 414px) {
  .sales-volumeDetails-container {
    .mobile {
      font-size: 14px;
      display: block;
      margin: -10px;
      .info-header {
        background: #fff;
        padding: 15px;
        line-height: 25px;

        .header-tag {
          background: #005cec;
          color: #fff;
          border-radius: 30px;
          padding: 2px 5px;
          margin-right: 10px;
          font-size: 10px;
        }
      }

      .order-details {
        padding: 15px 15px 0 15px;
        .title {
          &::before {
            content: "";
            display: inline-block;
            width: 4px;
            height: 14px;
            background: linear-gradient(
              180deg,
              rgba(81, 161, 255, 1),
              rgba(138, 124, 255, 1)
            );
            box-shadow: 0px 0px 16px 0px rgba(216, 216, 216, 0.79);
            margin-right: 5px;
            border-radius: 5px 0 5px 0;
          }
        }
      }

      .price {
        color: #f72b2b;
      }

      .list {
        background: #fff;
        margin-top: 10px;
        .price {
          font-size: 16px;
        }
        .list-item {
          padding: 15px 15px 15px 0;
          margin-left: 15px;
          border-bottom: 1px solid #efefef;
          color: #999;
          line-height: 25px;
        }
        .count {
          color: #589dff;
        }
        .tag {
          height: 18px;
          line-height: 18px;
          background: linear-gradient(
            90deg,
            rgba(81, 161, 255, 1),
            rgba(138, 124, 255, 1)
          );
          color: #fff;
          font-size: 11px;
          border-radius: 30px;
          padding: 0 5px;
          margin-right: 5px;
        }
        .user-info {
          margin-right: 5px;
          color: #2b2b2b;
        }
      }

      .img-wrapper {
        width: 78px;
        height: 78px;
        border-radius: 5px;
        margin-right: 10px;
        margin-top: 10px;
        img {
          height: 100%;
          width: 100%;
        }
      }

      .total {
        padding: 15px;
        background: #fff;
      }

      .footer {
        background: #fff;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        height: 49px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      }

      .details-container {
        padding-bottom: 70px;
      }

      .progress {
        padding: 15px;
      }

      .status {
        margin-right: 10px;
        &.active {
        }
      }

      .btn {
        width: 140px;
        height: 36px;
        border-radius: 30px;
        border: none;
        color: #fff;
        &:active,
        &:focus {
          outline: none;
          border: none;
        }
      }

      .pass-btn {
        background: #005ceb;
      }

      .reject-btn {
        background: rgba(247, 43, 43, 1);
      }

      .upload-img {
        margin-top: 10px;
      }

      .line {
        height: 50px;
        width: 1px;
        background: #dddddd;
        margin-right: 11px;
        position: relative;
        &::before {
          position: absolute;
          top: 0;
          left: -2px;
          content: "";
          background: #ddd;
          width: 6px;
          height: 6px;
          border-radius: 50%;
        }
        &.active::before {
          background: #005ceb;
        }
      }
    }
  }
}
</style>
